import type { ConversationSummary } from "@beacon/core/chat"
import { conversationHref } from "./unread.ts"

/*
 * The Member's Beacon DM, as Chat's lists show it: always first under Direct messages, named
 * "Beacon" by Beacon's mark, whether or not it has been made yet. Until it has, its row opens
 * `beaconDmPath`, which makes it and goes on to it.
 */

/** The page that opens the Member's Beacon DM, making it the first time. */
export const beaconDmPath = "/chat/beacon"

/** The Member's Beacon DM among their conversations, once it has been made. */
export const beaconDmOf = (conversations: readonly ConversationSummary[]) =>
  conversations.find(({ kind }) => kind === "beacon")

/** Where the Beacon DM's row opens: the conversation, once made, or the page that makes it. */
export const beaconDmHref = (dm: ConversationSummary | undefined) =>
  dm ? conversationHref(dm) : beaconDmPath

/**
 * The Member's direct messages with people, apart from their Beacon DM, which leads the list on its
 * own row.
 */
export const dmsWithPeople = (conversations: readonly ConversationSummary[]) =>
  conversations.filter(({ kind }) => kind === "dm" || kind === "group-dm")
